/* ==========================================================================
   ProductCardCirRxjs > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'ProductCardCirRxjs',
    init: true,
    start: true,
    css: {
        base: 'product-card-cir-rxjs',
        soldOut: 'product-card-cir-rxjs--sold-out',
        price: 'product-card-cir-rxjs__price',
        active: 'is-active'
    },
    type: {
        image: 'product-card-cir-rxjs-image',
        secondaryImage: 'product-card-cir-rxjs-secondary-image',
        navButton: 'product-card-cir-rxjs-nav-button'
    },
    icons: {
        info: 'info',
        safe: 'earth-shield'
    },
    iconBrand: {
        cir: 'earth-arrow',
        com: 'map-markers',
        rut: 'car-routes',
        hon: 'hearts',
        ter: 'marker-compass'
    },
    image: {
        alternative: '/comun/images/not-available.png',
        resize: {
            width: 268,
            height: 145
        }
    }
};

module.exports = () => config;
